import AppIcon from "../components/AppIcon";
import { useEffect, useRef, useState } from "react";
import { IMAGES } from "../constants/images";
import Sidebar from "../components/Sidebar";
import { useUser } from "../contexts/UserContext";
import useMoveTo from "../constants/navigation";
import MobileHeader from "../components/MobileHeader";

const EditChatBackground = () => {
    const navigate = useMoveTo();
    const { currentUser, refreshUser } = useUser();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const chatBgInputRef = useRef(null);

    const [form, setForm] = useState({
        chatBg: null,
    });

    const handleChatBGUpload = (e) => {
        setForm({ ...form, chatBg: e.target.files[0] });
    };

    const triggerChatBGUpload = () => {
        chatBgInputRef.current?.click();
    };

    const handleSave = async () => {
        if (!currentUser) return;


    };

    return (
        <div className="h-screen bg-white text-black dark:bg-[#23272c] dark:text-white overflow-y-auto">
            <MobileHeader />

            <div className="flex">
                <Sidebar />

                <main className="flex-1 h-screen pt-5 pb-20 px-6 overflow-y-auto bg-white text-black dark:bg-[#23272c] dark:text-white">
                    <div className="flex items-center justify-between">
                        <button onClick={() => navigate(-1)} className="flex-shrink-0">
                            <AppIcon name="arrowBack" className="w-4 h-4 md:w-5 md:h-5 brightness-0 dark:invert" alt="Back" />
                        </button>
                        <h2 className="text-2xl md:text-3xl font-semibold">Edit Chat Background</h2>
                        <div />
                    </div>

                    <div className="max-w-xl mx-auto pt-10 lg:pt-28 space-y-6">

                        {/* Showreel Upload */}
                        <div
                            className="w-full rounded-xl px-4 py-3 outline-none placeholder:text-[#7C8BA0] bg-[#F5F9FE] dark:bg-white text-black dark:text-black border-dashed border-gray-200 dark:border-0"
                            onClick={triggerChatBGUpload}
                        >
                            <input
                                ref={chatBgInputRef}
                                type="file"
                                accept="video/mp4,video/mov"
                                className="hidden"
                                onChange={handleChatBGUpload}
                            />
                            <AppIcon name="upload" className="mx-auto mb-2 w-12 h-12 lg:w-16 lg:h-16" alt="Upload" />
                            <p className="text-md md:max-w-64 mx-auto">
                                Click to upload your custom image to display behind your chats. Recommended 16:9 (.png, .jpg, .jpeg)
                            </p>
                        </div>

                        <button
                            onClick={handleSave}
                            className="bg-primary text-white text-lg font-semibold py-3 rounded-xl w-full mt-4"
                        >
                            {isSubmitting ? "Saving..." : "Save Chat Background"}
                        </button>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default EditChatBackground;
